import React from "react";
import { Modal, ModalHeader, ModalBody } from "@windmill/react-ui";

const ViewFeedbackModal = ({ isOpen, onClose, data }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
  <ModalHeader className="font-semibold text-lg border-b pb-2">
    Client Feedback
  </ModalHeader>

  <ModalBody className="space-y-5">

    <div className="bg-gray-50 p-4 rounded-md shadow-sm border space-y-3">
      <p className="text-sm">
        <strong>Driver Friendly:</strong>{" "}
        <span className={data?.query_driver === 1 ? "text-green-600" : "text-red-600"}>
          {data?.query_driver === 1 ? "Yes" : "No"}
        </span>
      </p>

      <p className="text-sm">
        <strong>Vehicle Clean:</strong>{" "}
        <span className={data?.query_vehicle === 1 ? "text-green-600" : "text-red-600"}>
          {data?.query_vehicle === 1 ? "Yes" : "No"}
        </span>
      </p>

      <p className="text-sm">
        <strong>Driver Departure:</strong>{" "}
        <span className={data?.query_depart === 1 ? "text-green-600" : "text-red-600"}>
          {data?.query_depart === 1 ? "Yes" : "No"}
        </span>
      </p>

      <p className="text-sm">
        <strong>Covered Itinerary:</strong>{" "}
        <span className={data?.query_itinerary === 1 ? "text-green-600" : "text-red-600"}>
          {data?.query_itinerary === 1 ? "Yes" : "No"}
        </span>
      </p>

      <p className="text-sm">
        <strong>Driver Rating:</strong>{" "}
        <span className="font-medium">{data?.driver_rating}</span>
      </p>

      <p className="text-sm">
        <strong>Vehicle Rating:</strong>{" "}
        <span className="font-medium">{data?.vehicle_rating}</span>
      </p>
    </div>

    <div className="bg-gray-50 p-4 rounded-md shadow-sm border">
      <p className="font-medium text-sm"><strong>Additional Comment:</strong></p>
      <p className="text-sm text-gray-700 mt-2 whitespace-pre-wrap">
        {data?.additional_comment || "No comment"}
      </p>
    </div>

  </ModalBody>
</Modal>
  );
};

export default ViewFeedbackModal;
